import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { yarnPublicAPI } from '@/lib/yarnsAPI';
import { clientSession } from '@/lib/clientsAPI';
import YarnThread from './YarnThread';

// The client's view of an open yarn: secure link, no account.
export default function YarnGuest() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [missing, setMissing] = useState(false);
  const load = useCallback(() => yarnPublicAPI.get(token).then((r) => setData(r.data)).catch(() => setMissing(true)), [token]);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#FBF8F2', color: '#1E2A33', fontFamily: 'Manrope, Arial, sans-serif' }}>
      <header className="border-b bg-white" style={{ borderColor: '#E3DDD1' }}>
        <div className="max-w-2xl mx-auto px-4 py-3 flex items-center gap-3">
          <img src="/stagehead-os-mark.svg" alt="" className="w-8 h-8" />
          <div className="leading-tight min-w-0">
            <div className="font-semibold truncate" style={{ fontFamily: 'Fraunces, Georgia, serif' }}>{data?.title || 'Conversation'}</div>
            {data?.company && <div className="text-xs text-[#5C6670]">with {data.company} · on Stagehead</div>}
          </div>
          {clientSession.get() && <a href="/client" className="ml-auto text-sm font-semibold text-[#A62B1F] shrink-0">My portal</a>}
        </div>
      </header>
      <main className="flex-1 max-w-2xl w-full mx-auto px-4 py-4 flex flex-col min-h-0" style={{ height: 'calc(100vh - 60px)' }}>
        {missing ? (
          <div className="rounded-xl border bg-white p-6" style={{ borderColor: '#E3DDD1' }}>This conversation link isn't valid any more. If you think that's a mistake, contact the person who sent it.</div>
        ) : !data ? (
          <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin" /></div>
        ) : (
          <div className="flex-1 min-h-0 rounded-xl border bg-white p-3 md:p-4 flex flex-col" style={{ borderColor: '#E3DDD1' }}>
            <YarnThread posts={data.posts} isMine={(p) => !!p.mine}
              onSend={async (text, files) => { await yarnPublicAPI.post(token, text, files); await load(); }}
              onOpenFile={(f) => window.open(yarnPublicAPI.fileUrl(token, f.id), '_blank')}
              disabled={data.archived} disabledNote="This conversation has been closed."
              placeholder={`Reply as ${data.me.name}…`} />
          </div>
        )}
      </main>
    </div>
  );
}
